// Types
import type { TTextFieldProps, TTextFieldSize, TTextFieldStatus, TTextFieldVariant } from './TextField.type';

export const TEXT_FIELD_SIZES: TTextFieldSize[] = ['sm', 'md', 'lg'];
export const TEXT_FIELD_SIZE: { [key in TTextFieldSize]: key } = {
	sm: 'sm',
	md: 'md',
	lg: 'lg',
};

export const TEXT_FIELD_STATUSES: TTextFieldStatus[] = ['default', 'error', 'success'];
export const TEXT_FIELD_STATUS: { [key in TTextFieldStatus]: key } = {
	default: 'default',
	error: 'error',
	success: 'success',
};

export const TEXT_FIELD_VARIANTS: TTextFieldVariant[] = ['inline', 'outline'];
export const TEXT_FIELD_VARIANT: { [key in TTextFieldVariant]: key } = {
	inline: 'inline',
	outline: 'outline'
};

export const TEXT_FIELD_DEFAULT_PROPS: TTextFieldProps = {
	size: TEXT_FIELD_SIZE.md,
	status: TEXT_FIELD_STATUS.default,
	variant: TEXT_FIELD_VARIANT.outline,
};
